import { useEffect, useRef, useState } from 'react';

export function usePriceFlash<T extends number | string>(
  currentValue: T,
  options: {
    duration?: number;
    upClass?: string;
    downClass?: string;
  } = {}
): string {
  const { duration = 2000, upClass = 'bg-blue', downClass = 'bg-red' } = options;
  const [flashClass, setFlashClass] = useState<string>('');
  const prevValueRef = useRef<T | null>(null);

  useEffect(() => {
    if (prevValueRef.current === null) {
      prevValueRef.current = currentValue;
      return;
    }

    if (currentValue !== prevValueRef.current) {
      const isUp = Number(currentValue) > Number(prevValueRef.current);
      const newClass = isUp ? upClass : downClass;

      setFlashClass(newClass);

      const timer = setTimeout(() => {
        setFlashClass('');
      }, duration);

      prevValueRef.current = currentValue;

      return () => clearTimeout(timer);
    }
  }, [currentValue, duration]);

  return flashClass;
}
